import { SearchGnavInputFieldIcon } from './SearchGnavInputFieldIcon';

/*eslint no-restricted-syntax: ["off"]*/
export default SearchGnavInputFieldIcon;
